export const PRIVATE_LABEL_CONSTANTS = Object.freeze({
  FILE_UPLOAD: {
    SIZE_LIMIT: '400MB',
    EXTENSIONS: 'image/png, image/jpeg, image/jpg',
    SERVER_URL: '/v1/images',
    PREVIEW_SIZE: {
      WIDTH: 112,
      HEIGHT: 112
    }
  },
  FORM: {
    NAME_MAX_LENGTH: 50,
    PREVIEW_PLACEHOLDER: 'Image upload required'
  },
  SUGGESTIONS: [
    {
      label: 'Miru 1month',
      id: '99999999-2222-2222-2222-111111111111'
    },
    {
      label: 'Miru 1day flatpack',
      id: '99999999-1111-1111-1111-111111111111'
    }
  ]
} as const);
